// extracted by mini-css-extract-plugin
export default {"element":"PrivateGuild_element__B5q1g","wrapper":"PrivateGuild_wrapper__o+Bm1"};